function createBatchRequest(form) {
  const formData = new FormData();
  formData.append('file', form.file);
  formData.append('template_id', form.template_id);
  formData.append('label', form.label);
  formData.append('tag', form.tag);
  formData.append('recurrent', form.recurrent);
  formData.append('periodicity', form.periodicity);
  formData.append('name', form.name);

  return formData;
}

const actions = {
  async calculateTotal({ commit, rootState: { $http } }, form) {
    const formData = createBatchRequest(form);

    const { data } = await $http.post('/query/batch/total', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    commit('setTotal', data.total);
  },

  async create({ rootState: { $http } }, form) {
    const formData = createBatchRequest(form);

    await $http.post('/query/batch', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default actions;
